/* Re. product cards: swipe through a pair's photos on touch screens without opening the product page.
   Only on touch devices, only for cards that are not inside a sideways scroller (so carousels keep scrolling). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  function inScroller(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var ox = getComputedStyle(n).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && n.scrollWidth > n.clientWidth + 4) return true;
    }
    return false;
  }
  function key(u) { try { return new URL(u, location.href).pathname.split('/').pop(); } catch (e) { return u; } }
  function raw(card) { return (card.getAttribute('data-imgs') || '').split('|').filter(Boolean); }
  /* The list always starts with the photo the card is showing now (the collection page can switch between studio and on-face shots). */
  function list(card) {
    var img = card.querySelector('.rd2-card__a'), cur = img ? key(img.currentSrc || img.src) : '';
    if (card._rdList && cur === card._rdCur) return card._rdList;
    var all = raw(card), first = null, rest = [];
    all.forEach(function (u) { if (!first && key(u) === cur) first = u; else rest.push(u); });
    card._rdList = first ? [first].concat(rest) : all; card._rdCur = cur; card._rdIdx = 0;
    return card._rdList;
  }
  function dots(card, n, i) {
    var well = card.querySelector('.rd2-card__well'); if (!well || n < 2) return;
    var d = well.querySelector('.rd-pc__dots');
    if (!d) { d = document.createElement('span'); d.className = 'rd-pc__dots'; d.setAttribute('aria-hidden', 'true'); well.appendChild(d); }
    var h = ''; for (var k = 0; k < n; k++) h += '<i' + (k === i ? ' class="on"' : '') + '></i>';
    d.innerHTML = h;
  }
  var st = null;
  document.addEventListener('touchstart', function (e) {
    var well = e.target.closest && e.target.closest('[data-rd2-card] .rd2-card__well');
    if (!well || e.touches.length !== 1) { st = null; return; }
    var card = well.closest('[data-rd2-card]');
    if (list(card).length < 2 || inScroller(card)) { st = null; return; }
    st = { card: card, x: e.touches[0].clientX, y: e.touches[0].clientY, h: null };
    if (!card._rdPre) { card._rdPre = 1; list(card).slice(0, 3).forEach(function (u) { var im = new Image(); im.src = u; }); }
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!st) return;
    var dx = e.touches[0].clientX - st.x, dy = e.touches[0].clientY - st.y;
    if (st.h === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) st.h = Math.abs(dx) > Math.abs(dy) * 1.3;
    if (st.h) e.preventDefault();
  }, { passive: false });
  document.addEventListener('touchend', function (e) {
    if (!st || !st.h) { st = null; return; }
    var dx = e.changedTouches[0].clientX - st.x, card = st.card; st = null;
    if (Math.abs(dx) < 35) return;
    var urls = list(card), img = card.querySelector('.rd2-card__a'); if (!img) return;
    var i = card._rdIdx || 0;
    i = dx < 0 ? Math.min(urls.length - 1, i + 1) : Math.max(0, i - 1);
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = urls[i];
    card._rdIdx = i; card._rdCur = key(urls[i]);
    var well = card.querySelector('.rd2-card__well'); if (well) well.style.background = '#F0EEEB';
    card._rdSwiped = Date.now(); dots(card, urls.length, i);
    var nx = urls[i + 1]; if (nx) { var p = new Image(); p.src = nx; }
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-rd2-card]');
    if (card && card._rdSwiped && Date.now() - card._rdSwiped < 500) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  /* Show the dots once, so people can tell a card has more photos. */
  function init() {
    document.querySelectorAll('[data-rd2-card][data-imgs]').forEach(function (c) {
      if (c._rdDots) return; c._rdDots = 1; var n = raw(c).length;
      if (n > 1 && !inScroller(c)) dots(c, n, 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function () { window.requestAnimationFrame(init); }).observe(document.documentElement, { childList: true, subtree: true });
})();
